<script lang="ts">
  import { orgMagnifier } from "@nrk/origo";
  import type { Collection } from "bildebanken-model";
  import { displayName } from "./collectionOperations";

  export let allCollections: Collection[];
  export let selectedCollectionId: string;

  let searchTerm: string = "";
  let searchFieldFocus: boolean = false;

  $: filtered = searchTerm
    ? allCollections.filter((c) => displayName(c).toLowerCase().includes(searchTerm.toLowerCase()))
    : allCollections;
</script>

<label for="select-collection">
  Eksisterende samlinger
  <div class="search-wrapper" class:focus={searchFieldFocus}>
    {@html orgMagnifier}
    <input
      type="search"
      placeholder="Søk etter samling..."
      bind:value={searchTerm}
      on:focus={() => (searchFieldFocus = true)}
      on:blur={() => (searchFieldFocus = false)}
    />
  </div>
</label>
<select class="org-input" id="select-collection" bind:value={selectedCollectionId}>
  <option value="">-- Velg samling --</option>
  {#each filtered as collection}
    <option value={collection.id}>{displayName(collection)}</option>
  {/each}
</select>

<style>
  select {
    margin-bottom: var(--org-xsmall);
    margin-top: var(--org-small);
    width: 100%;
  }

  .search-wrapper {
    display: flex;
    align-items: center;
    gap: var(--org-xsmall);
    border: 1px solid var(--org-color-shade-2);
    border-radius: 3px;
    padding: 0 var(--org-small);
    margin-top: var(--org-xsmall);
    background-color: var(--color-surface-primary);
    height: 36px;
  }
  .search-wrapper.focus {
    box-shadow: var(--org-shadow-focus);
    flex-grow: 1;
  }

  .search-wrapper :global(svg) {
    flex-shrink: 0;
    font-size: 12px;
  }

  .search-wrapper input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    padding: var(--org-xsmall) 0;
    font-size: inherit;
    color: var(--color-text-primary);
  }
</style>
